/*
Author : Abaid ullah
Module: Visitor Types
github: https://github.com/abaid
*/

import { createAsyncThunk } from '@reduxjs/toolkit';
import { apiInstanceV2 } from '../../Apis/AxiosV2';

const GET_VISITOR_TYPE_BY_ID = 'visitor-types-service/get-by-id';
const CREATE_VISITOR_TYPES = 'visitor-types-service/create';
const UPDATE_VISITOR_TYPES = 'visitor-types-service/update';

// create visitorTypes
export const CreateVisitorTypes = createAsyncThunk(
    'visitorTypes/createVisitorTypes',
    async (params, { dispatch, getState }) => {
        const result = await apiInstanceV2
            .post(CREATE_VISITOR_TYPES, params)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);
// update visitorTypes
export const UpdateVisitorTypes = createAsyncThunk(
    'visitorTypes/updateVisitorTypes',
    async (params, { dispatch, getState }) => {
        const result = await apiInstanceV2
            .put(UPDATE_VISITOR_TYPES, params)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);


// get visitorTypes by it id
export const GetVisitorTypeById = createAsyncThunk(
    'visitorTypes/getVisitorTypeById',
    async (params, { dispatch, getState }) => {
        const result = await apiInstanceV2
            .get(`${GET_VISITOR_TYPE_BY_ID}/${params}`)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);
